import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  list: {
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    ...shorthands.padding("6px", "18px", "0px", "18px"),
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginRight: "40px",
      width: "100%",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("auto"),
      width: "840px",
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginRight: "200px",
      width: "100%",
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("auto"),
      width: "1040px",
    },
  },
  white: {
    backgroundColor: "white",
    height: "1px",
  },
});
